import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class DoctorDetail extends React.Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired,
    specialities: PropTypes.string.isRequired
  };

  render() {
    const { fullName, specialities, themeColors } = this.props;

    return (
      <>
        <Text style={styles.fullName}>{fullName}</Text>
        <Text
          style={[
            styles.specialities,
            {
              color: themeColors.lighterPrimary
            }
          ]}
        >
          {specialities}
        </Text>
      </>
    );
  }
}

const styles = StyleSheet.create({
  fullName: {
    color: staticColors.cavernous,
    fontSize: 14,

    ...fonts.bold
  },
  specialities: {
    fontSize: 12,

    ...fonts.regular
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(DoctorDetail);
